"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockUserProfilePublic = exports.mockUserProfilePrivate = void 0;
const species_1 = require("./species");
const user_1 = require("./user");
function mockUserProfilePrivate(overrides = {}) {
    return {
        brands: [],
        description: 'mock description',
        facebook: null,
        image: 'https://example.com/20190329161749.jpg',
        instagram: null,
        location: 'mock location, USA',
        slug: 'user_profile_slug',
        species: [(0, species_1.mockSpecies)()],
        tiktok: null,
        title: null,
        twitter: null,
        user: (0, user_1.mockUserPublic)(),
        website: null,
        youtube: null,
        youtube_title: null,
        ...overrides,
    };
}
exports.mockUserProfilePrivate = mockUserProfilePrivate;
function mockUserProfilePublic(overrides = {}) {
    return {
        ...mockUserProfilePrivate(overrides),
        banner_image: 'http://example.com/banner.jpg',
        email: 'mock@example.com',
        lists: [],
        organizations: [],
        phone: '123-456-7890',
        user_event_notifications: {
            new_fishing_report: false,
            new_article: false,
            frequency: 'weekly',
        },
        user_favorite: false,
        waterbodies: [],
        ...overrides,
    };
}
exports.mockUserProfilePublic = mockUserProfilePublic;
